import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(theme => ({
  toggledTitle: {
    display: "flex",
    justifyContent: "space-between"
  }
}))
